import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/** Keep the complete translated slogan on one line at its natural proportions. */
export function AuthBrandTagline({ style }: { style?: React.CSSProperties }) {
  const { t } = useTranslation();
  const text = t('auth.brandTagline');
  const ref = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    let active = true;
    const fit = () => {
      if (!active) return;
      element.style.fontSize = typeof style?.fontSize === 'number'
        ? `${style.fontSize}px` : style?.fontSize ?? '';
      const available = element.clientWidth;
      const needed = element.scrollWidth;
      if (available > 0 && needed > available) {
        const size = parseFloat(getComputedStyle(element).fontSize);
        element.style.fontSize = `${Math.floor(size * available / needed * 100) / 100}px`;
      }
    };
    fit();
    const observer = new ResizeObserver(fit);
    if (element.parentElement) observer.observe(element.parentElement);
    void document.fonts.ready.then(fit);
    document.fonts.addEventListener('loadingdone', fit);
    return () => {
      active = false;
      observer.disconnect();
      document.fonts.removeEventListener('loadingdone', fit);
    };
  }, [text, style?.fontSize]);

  return <p ref={ref} className="auth-brand-tagline" dir="auto"
    style={{ ...style, whiteSpace: 'nowrap', width: '100%' }}>{text}</p>;
}
